

export function normalizeDigits(str) {
  if (typeof str !== "string") return str;
  return str.replace(/[\u0AE6-\u0AEF]/g, (ch) =>
    String.fromCharCode(ch.charCodeAt(0) - 0x0AB6)
  );
}

export function checkIfAnyError(internalValidationErrors){
    var errorExist = false;

    for (var key in internalValidationErrors){
        if (internalValidationErrors[key] != ""){
            errorExist = true;
        }  
    }
    return errorExist
}

export function safeParseInt(str) {
  if (str === "" || str === null || str === undefined) return 0;
  return parseInt(normalizeDigits(str));
}

export function safeParseFloat(str) {
  if (str === "" || str === null || str === undefined) return 0;
  return parseFloat(normalizeDigits(str));
}